import { render, staticRenderFns } from "./CadastrarVideo.vue?vue&type=template&id=c1677afa&scoped=true"
import script from "./CadastrarVideo.vue?vue&type=script&lang=js"
export * from "./CadastrarVideo.vue?vue&type=script&lang=js"
import style0 from "./CadastrarVideo.vue?vue&type=style&index=0&id=c1677afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1677afa",
  null
  
)

export default component.exports